import { render, staticRenderFns } from "./vendorLogin.vue?vue&type=template&id=841f80c2&scoped=true"
import script from "./vendorLogin.vue?vue&type=script&lang=js"
export * from "./vendorLogin.vue?vue&type=script&lang=js"
import style0 from "./vendorLogin.vue?vue&type=style&index=0&id=841f80c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841f80c2",
  null
  
)

export default component.exports